<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">

                <b-link class="" :to="{ path: '/' }">
                    <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
                </b-link>
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row">
                    <div class="col-md-12 text-center">
                      <h1>  Discrepancy Reports </h1>
                    </div>
                </div>
                <div class="row  mt-2">

                    <div class="col-md-2">
                        <v-select
                            v-model="filters.location"
                            class="text-light"
                            placeholder="Location"
                            :options="locations_stock"
                            :disabled="!authenticatedUser.permissions.includes('super')"
                            @input="getDiscrepancyReports"
                            label="location_name"
                            :reduce="option => option.location_name"
                        />
                    </div>
                    <div class="col-md-2">
                        <v-select
                            v-model="filters.supplier"
                            class="text-light"
                            placeholder="Supplier"
                            :options="suppliers"
                            @input="getDiscrepancyReports"
                            label="name"
                            :reduce="option => option.name"
                        />
                    </div>
                    <div class="col-md-3">
                        <date-picker v-model="filters.dateRange" range
                                     format="DD MMM, YYYY"
                                     value-type="format"
                                     :clearable="true"
                                     @input="getDiscrepancyReports"
                        ></date-picker>
                    </div>
                    <div class="col-md-1">
                        <b-input v-model="filters.time_from" placeholder="Time From" type="time"
                                 @input="getDiscrepancyReports"
                        ></b-input>
                    </div>
                    <div class="col-md-1">
                        <b-input v-model="filters.time_to" placeholder="Time To" type="time"
                                 @input="getDiscrepancyReports"
                        ></b-input>
                    </div>
                    <div class="col-md-2">
                        <button class="btn btn-info" @click="getDiscrepancyReports">
                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Refresh
                        </button>
                    </div>

                </div>

                <div class="row mt-2">
<!--                    <div class="col-md-12">-->
<!--                        <span class="text-light mx-2 px-2" v-if="!loading" style="border: 3px solid white; border-radius: 5px">Showing {{ discrepancies.length }} records</span>-->
<!--                    </div>-->
                </div>

                <div class="row" v-if="loading">
                    <div class="col-md-12 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12" >
                        <table class="table text-light border">
                            <thead>
                            <tr>
                                <th>Location</th>
                                <th>Supplier</th>
                                <th>Description</th>
                                <th>SKU</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>System Stock</th>
                                <th>Actual Stock</th>
                                <th>Adjustment</th>
                                <th>Unit Price</th>
                                <th>Discrepancy Cost</th>
                                <th>Reason</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="d in discrepancies" :key="d.id">
                                <td>{{ d.location }}</td>
                                <td>{{ d.supplier }}</td>
                                <td>{{ d.description }}</td>
                                <td>{{ d.item_code }}</td>
                                <td>{{ formatDateOnly(d.date_time) }}</td>
                                <td>{{ formatTimeOnly(d.date_time) }}</td>
                                <td>{{ d.system_stock }}</td>
                                <td>{{ d.actual_stock }}</td>
                                <td>{{ d.adjustment }}</td>
                                <td>{{ d.unit_price }}</td>
                                <td>{{ d.discrepancy_cost }}</td>
                                <td>{{ d.reason }}</td>
                            </tr>
                            <tr v-if="discrepancies.length === 0 && !loading">
                                <td colspan="12" class="text-center">No records found.</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="row mt-2">

                    <div class="col-md-1 ">

                        <span class="text-light font-weight-bold " v-if="grandTotal!=0">   Grand Total</span>
                    </div>
                    <div class="col-md-1 offset-9">

                        <span class="text-light font-weight-bold " v-if="grandTotal!=0"> {{ grandTotal }}</span>
                    </div>
                    <div class="col-md-1 text-right">
                        <button class="btn btn-success btn-sm" @click="downloadCSV">
                            Download CSV
                        </button>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import apiService from "@/service/apiService";
import axios from "axios";
import BaseURL from "@/constants/baseurl";
import Loader from "@/components/loader";
import Welcomenote from "@/pages/admin/mypos/welcomenote";
import moment from "moment";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    name: "discrepancy-reports",

    components:{'v-select': vSelect, Welcomenote, Loader, DatePicker,'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),
        grandTotal() {
            return this.discrepancies.reduce((sum, d) => {
                const cost = parseFloat(d.discrepancy_cost);
                return sum + (isNaN(cost) ? 0 : cost);
            }, 0).toFixed(2);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        locations_stock(){
            if(this.authenticatedUser.permissions.includes('super')){
                return this.locations
            } else {
                return this.locations.filter((lc)=>[this.locations.find((bl)=>bl.branch_id==this.authenticatedUser.branch_id).id].includes(lc.id))
            }
        },
    },
    data() {
        return {
            suppliers:[],
            locations:[],
            loading:false,
            discrepancies:[],
            filters: {
                location: '',
                supplier: '',
                dateRange: [null, null],
                time_from: '',
                time_to: '',
            },
        };
    },
    async created() {
        this.loading=true
        await this.getlocations()
        await this.getsuppliers()
        await this.getDiscrepancyReports()
        this.loading=false
    },
    async mounted() {


    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),

        async getsuppliers(){
            const {data} = await apiService.get(`/suppliers`);
            this.suppliers=data
        },

        formatDate(date){
            if (!date) return '';
            let date1 = new Date(date);
            let date2 =  moment(date1).format('D MMM, YYYY, h:mm A');
            return date2;
        },
        formatDateOnly(date){
            if (!date) return '';
            let date1 = new Date(date);
            return moment(date1).format('D MMM, YYYY');
        },
        formatTimeOnly(date){
            if (!date) return '';
            let date1 = new Date(date);
            return moment(date1).format('h:mm A');
        },
        downloadCSV() {
            if (this.discrepancies.length === 0) return;

            const headers = [
                'Location', 'Supplier', 'Description', 'SKU', 'Date',
                'Time', 'System Stock', 'Actual Stock', 'Adjustment',
                'Unit Price', 'Discrepancy Cost', 'Reason'
            ];

            // Calculate total discrepancy cost
            const totalDiscrepancyCost = this.discrepancies.reduce((sum, d) => {
                const cost = parseFloat(d.discrepancy_cost);
                return sum + (isNaN(cost) ? 0 : cost);
            }, 0);

            const rows = this.discrepancies.map(d => [
                `"${d.location || ''}"`,
                `"${d.supplier || ''}"`,
                `"${(d.description || '').replace(/"/g, '""')}"`,
                `"${d.item_code || ''}"`,
                `"${this.formatDateOnly(d.date_time)}"`,
                `"${this.formatTimeOnly(d.date_time)}"`,
                `"${d.system_stock !== null ? d.system_stock : ''}"`,
                `"${d.actual_stock !== null ? d.actual_stock : ''}"`,
                `"${d.adjustment !== null ? d.adjustment : ''}"`,
                `"${d.unit_price !== null ? d.unit_price : ''}"`,
                `"${d.discrepancy_cost !== null ? d.discrepancy_cost : ''}"`,
                `"${(d.reason || '').replace(/"/g, '""')}"`
            ].join(','));

            // Construct the grand total row
            const totalRow = [
                '"Grand Total"', // Location
                '""',             // Supplier
                '""',             // Description
                '""',             // SKU
                '""',             // Date
                '""',             // Time
                '""',             // System Stock
                '""',             // Actual Stock
                '""',             // Adjustment
                '""',             // Unit Price
                `"${totalDiscrepancyCost.toFixed(2)}"`, // Discrepancy Cost
                '""'              // Reason
            ].join(',');

            const csv = [headers.join(','), ...rows, totalRow].join('\n');

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', `discrepancy-reports-${moment().format('YYYY-MM-DD')}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        async getlocations(){
            const {data} = await apiService.get(`/locations`);
            this.locations=data
        },

        async getDiscrepancyReports() {
            this.loading=true
            const apiToken = localStorage.getItem('token');
            if (apiToken) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
            }
            try {
                const res = await axios.post(`${BaseURL.BASEURL}/api/discrepancy-reports`, this.filters);

                if (res) {
                    this.loading=false
                    this.discrepancies=res.data
                }
            } catch (error) {
                console.error(error);
                this.loading=false
            }
        },

        async signOut() {
            await this.processLogoutManual();
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },


    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
</style>
